__webpack_require__.p = "/mailbox-data/referrals/";